import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pContractorPlanDetailList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}/p_contractor_plan_detail_list`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};


export const pContractorPlanDetailUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.contractorService}/p_contractor_plan_detail_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};